/* eslint-disable */
// @ts-nocheck

import { useQuery } from '@tanstack/react-query'

import {
  getManagers,
  getProviders,
  getStorages,
  getTransporters,
} from '@/api/providersAPI'

interface CompanyNamesCache {
  providers: Map<string, string>
  managers: Map<string, string>
  transporters: Map<string, string>
  storages: Map<string, string>
}

// Cache global para nombres de compañías
const companyNamesCache: CompanyNamesCache = {
  providers: new Map(),
  managers: new Map(),
  transporters: new Map(),
  storages: new Map(),
}

export const useCompanyNames = () => {
  // Cargar proveedores
  const { data: providers } = useQuery({
    queryKey: ['company-names-providers'],
    queryFn: () => getProviders({ per_page: 1000 }),
    staleTime: 10 * 60 * 1000, // 10 minutos
  })

  // Cargar operadores logísticos
  const { data: managers } = useQuery({
    queryKey: ['company-names-managers'],
    queryFn: () => getManagers({ per_page: 1000 }),
    staleTime: 10 * 60 * 1000, // 10 minutos
  })

  // Cargar transportistas
  const { data: transporters } = useQuery({
    queryKey: ['company-names-transporters'],
    queryFn: () => getTransporters({ per_page: 1000 }),
    staleTime: 10 * 60 * 1000, // 10 minutos
  })

  // Cargar almacenes
  const { data: storages } = useQuery({
    queryKey: ['company-names-storages'],
    queryFn: () => getStorages({ per_page: 1000 }),
    staleTime: 10 * 60 * 1000, // 10 minutos
  })

  // Actualizar cache cuando se cargan los datos
  if (providers) {
    providers.forEach((company: any) => {
      companyNamesCache.providers.set(company.id.toString(), company.name)
    })
  }

  if (managers) {
    managers.forEach((company: any) => {
      companyNamesCache.managers.set(company.id.toString(), company.name)
    })
  }

  if (transporters) {
    transporters.forEach((company: any) => {
      companyNamesCache.transporters.set(company.id.toString(), company.name)
    })
  }

  if (storages) {
    storages.forEach((company: any) => {
      companyNamesCache.storages.set(company.id.toString(), company.name)
    })
  }

  // Funciones para obtener nombres por ID
  const getProviderName = (id: string): string => {
    return companyNamesCache.providers.get(id) || `Proveedor ID ${id}`
  }

  const getManagerName = (id: string): string => {
    return companyNamesCache.managers.get(id) || `Operador Logístico ID ${id}`
  }

  const getTransporterName = (id: string): string => {
    return companyNamesCache.transporters.get(id) || `Transportista ID ${id}`
  }

  const getStorageName = (id: string): string => {
    return companyNamesCache.storages.get(id) || `Almacén ID ${id}`
  }

  return {
    getProviderName,
    getManagerName,
    getTransporterName,
    getStorageName,
  }
}
